import React  from 'react';
import shichangbuzuoyeliucheng from '../assets/img/shichangbuzuoyeliucheng.png';
import zhudonghuoke from '../assets/img/zhudonghuoke.png';
const Enclosure612 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3 style={{fontWeight:'bold'}}></h3>
            <img src={shichangbuzuoyeliucheng} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={zhudonghuoke} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>


export default Enclosure612;